/** 提现 */
<template>
  <div class="margin-top-20">
    <BasiceLayout
      :title="$t('buyBackTitle') "
      class="withdrawal-layout"
      empty-text="loading"
    >
      <el-table
        v-if="buyBackList !== 'NONE'"
        :data="buyBackList"
        style="width: 100%;min-height: 200px"
      >
        <el-table-column
          prop="time"
          label="发起时间（UTC）"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="exchangeMoney"
          label="提现金额"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="exchangeBXC"
          label="提现所需BxC数量"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="ZFBAccount"
          label="收款支付宝账号"
          align='center'
        >
        </el-table-column>
      </el-table>
      <el-table
        v-if="buyBackList === 'NONE'"
        :empty-text="$t('withdrawal.recordsList.noWithdrawalList')"
      ></el-table>
    </BasiceLayout>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";

export default {
  name: "AccountLayout",
  components: {
    BasiceLayout,
  },
  props: {},
  computed: mapState({
    //  箭头函数可使代码更简练
    buyBackList: (state) => state.buyBack.buyBackList,
  }),
  methods: {
    ...mapActions(["getBuyBackList"]),
  },
  created() {
    this.getBuyBackList();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus"></style>

<i18n>
{
	"en": {
		"buyBackTitle": "提现记录",
		"buyBackTime": "发起时间（UTC）",
		"buyBackAmount": "回购数量"
	},
	"zn": {
		"buyBackTitle": "提现记录",
		"buyBackTime": "发起时间（UTC）",
		"buyBackAmount": "回购数量"
	}
}
</i18n>
